export default "__VITE_ASSET__B6aLIbvr__"